import { render, staticRenderFns } from "./ThemeChanger.vue?vue&type=template&id=b3d1b9f6&scoped=true&"
import script from "./ThemeChanger.vue?vue&type=script&lang=js&"
export * from "./ThemeChanger.vue?vue&type=script&lang=js&"
import style0 from "./ThemeChanger.vue?vue&type=style&index=0&id=b3d1b9f6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3d1b9f6",
  null
  
)

export default component.exports